import React, { Fragment, Component } from 'react';
import D3Tree from 'react-d3-tree';
import { connect } from 'react-redux';
import { Button } from 'react-md';
import _ from 'lodash';
import './TreeContainer.scss';
import { SearchInput } from '../SearchInput/SearchInput';
import { setSearchTerm, clearSearchTerm } from '../../actions/filter.action';

let uncollapsedCount = 0;
const TreeNode = ({ nodeData }) => {
  return (
    <div
      className={`tree-node ${nodeData.className}`}
    >
      <h4>{nodeData.name}</h4>
      {
        nodeData.attributes &&
        <Fragment>
          {nodeData.attributes.type && <h6>Type: {nodeData.attributes.type}</h6>}
          {nodeData.attributes.role && <h6>Role: {nodeData.attributes.role}</h6>}
          {nodeData.attributes.operator && <h6>Operator: {nodeData.attributes.operator}</h6>}
          {!_.isEmpty(nodeData.attributes.viewers) && <h6>Viewer: {nodeData.attributes.viewers.map(item => item + ', ')}</h6>}
        </Fragment>
      }
    </div>
  );
};

class TreeContainer extends Component {

  state = {
    translateX: 0,
    translateY: 0
  };

  async componentDidMount() {
    setTimeout(() => {
      this.reset();
    }, 100);
  };

  goBack = () => {
    this.props.clearSearchTerm();
    this.props.previousStep();
  }
  reset = () => {
    const dimensions = this.treeContainer.getBoundingClientRect();
    this.setState({
      translateX: dimensions.width / 2,
      translateY: dimensions.height / 2
    });
  }


  navigateDown = () => {
    this.setState({
      translateY: this.state.translateY - 300
    });
  }

  navigateUp = () => {
    this.setState({
      translateY: this.state.translateY + 300
    });
  }

  navigateRight = () => {
    this.setState({
      translateX: this.state.translateX - 300
    });
  }

  navigateLeft = () => {
    this.setState({
      translateX: this.state.translateX + 300
    });
  }

  // this function is a necessity for the compiler to uniquely identify nodes,
  // and for users to alter their tree based off search results on the fly.
  formatter = (node, depth = 0) => {
    let finalNode = {};

    /* This keeps the package from crashing i.e. attempting to render too much data. */
    const renderControl = depth < 3 && uncollapsedCount < 10;

    const searchTerm = this.props.searchTerm === '' ? 'N/A' : this.props.searchTerm;
    /*
      IF the searchTerm is in the givin nodes name, the node is highlighted.
    */
    let selected = node.name.toLowerCase().includes(searchTerm);

    /* false means the organization is open */
    let collapsed = !(selected && renderControl);

    // eslint-disable-next-line
    if (!collapsed) uncollapsedCount += 1;

    if (node && node.children) {


      let children = node.children.map(descendent => {
        const childSelected = descendent.name.toLowerCase().includes(searchTerm);
        const childCollapsed = !(childSelected && renderControl);
        let reformed = {};

        if (descendent && descendent.children) {
          // If there is a match AND descendents.
          reformed = this.formatter(descendent, depth + 1);
        } else if (descendent && !descendent.children) {
          if (searchTerm  === 'N/A') {
            reformed = {
              ...descendent,
              id: descendent.name,
              children: [],
              _collapsed: childCollapsed
            };
          } else if (searchTerm !== 'N/A' && !childSelected) {
            reformed = {
              name: 'unselected'
            };
          } else if (searchTerm !== 'N/A' && childSelected) {
            reformed = {
              ...descendent,
              id: descendent.name,
              children: [],
              _collapsed: childCollapsed,
              className: 'node searchIncluded'
            };
          } else {
            reformed = {
              name: 'unselected'
            };
          }
        } else if (!childSelected && searchTerm !== 'N/A') {
          // If there is no match. no regard for further descendents
          reformed = { name: 'unselected', _collapsed: true, children: [] };
        } else {
          reformed = {
            ...descendent,
            children: [],
            id: descendent.name,
            _collapsed: childCollapsed,
            className: childSelected ? 'node searchIncluded' : 'node searchExcluded'
          };
        }
        return reformed;
      });
      // If any of the nodes descendents are searched the parent by default
      children = children.filter(item => item.name !== 'unselected');
      let childBooleanArray = children.map(child => this.collapsedCheck(child));
      childBooleanArray = this.flatten(childBooleanArray);
      // If any of the nodes descendents are searched the parent by default
      // must be uncollapsed.
      if (childBooleanArray.indexOf(false) !== -1 && searchTerm !== 'N/A') {
        uncollapsedCount++;
        collapsed = false;
        finalNode = {
          ...node,
          id: node.name,
          children,
          _collapsed: collapsed,
          className: selected ? 'node searchIncluded' : 'node searchExcluded'
        };
      } else {
        finalNode = {
          ...node,
          id: node.name,
          children,
          _collapsed: collapsed,
          className: selected ? 'node searchIncluded' : 'node searchExcluded'
        };
      }
      /* If there are descendents */
    } else {
      if (searchTerm === 'N/A') {
        finalNode = {
          ...node,
          id: node.name,
          children: [],
          _collapsed: collapsed
        };
      }
      if (searchTerm !== 'N/A' && selected) {
        finalNode = {
          ...node,
          id: node.name,
          children: [],
          _collapsed: collapsed,
          className: 'node searchIncluded'
        };
      } else {
        finalNode = {
          name: 'unselected',
          id: node.name,
          children: []
        };
      }
    }
    if (searchTerm !== 'N/A'){
      /*
        this statment gets rid of unselected branches of the tree:
        meaning if a child of the given node and none of there children are selected
        then the branch is filtered out.
      */
      finalNode.children = finalNode.children.filter(unit => {
        let childBooleanArray = this.selectedCheck(unit);
        childBooleanArray = this.flatten(childBooleanArray);
        return childBooleanArray.includes(true);
      });
    } else {
      /* returns the text back to its original font */
      finalNode.className = '';
    }
    return finalNode;
  }

  // A function that checks all of a nodes descendents for a uncollapsed node
  collapsedCheck = (tree) => {
    let finalArray = [];
    if (tree && !!!tree._collapsed) {
      finalArray = [...finalArray, tree._collapsed];
    }
    if (tree && tree.children) {
      finalArray = [...finalArray, tree.children.map( child => this.collapsedCheck(child))];
    }
    return this.flatten(finalArray);
  };

  // A function that checks all of a nodes descendents for a selected node
  selectedCheck = (tree) => {
    let finalArray = [];
    if (tree && tree.className === 'node searchIncluded') {
      finalArray = [...finalArray, true];
    }
    if (tree && tree.className === 'node searchExcluded') {
      finalArray = [...finalArray, false];
    }
    if (tree && tree.children) {
      finalArray = [...finalArray, tree.children.map( child => this.selectedCheck(child))];
    }
    return this.flatten(finalArray);
  };


  /*

  Found this one online:

  https://stackoverflow.com/questions/30048388/javascript-recursive-array-flattening

  */

  flatten(items) {
    const flat = [];

    items.forEach(item => {
      if (Array.isArray(item)) {
        flat.push(...this.flatten(item));
      } else {
        flat.push(item);
      }
    });

    return flat;
  }

  render() {
    uncollapsedCount = 0;
    const { data } = this.props;
    const root = this.formatter(data);
    return (
      <Fragment>
        <Button
          id="dialog-back-button"
          onClick={this.goBack}
          flat
          className='back-button'
          iconChildren='arrow_back'
        >choose a diffrent organization</Button>
        <Button
          onClick={this.navigateLeft}
          icon
          iconChildren='arrow_backwards'
        />
        <Button
          onClick={this.navigateUp}
          icon
          iconChildren='arrow_upwards'
        />
        <Button
          onClick={this.navigateDown}
          icon
          iconChildren='arrow_downwards'
        />
        <Button
          onClick={this.navigateRight}
          icon
          iconChildren='arrow_forwards'
        />
        <Button flat primary onClick={this.reset}>Re-center</Button>
        <SearchInput
          id='organizationTree'
          handleSearch={() => true}
          setSearchTerm={this.props.setSearchTerm}
          clearSearchTerm={this.props.clearSearchTerm}
          searchTerm={this.props.searchTerm}
        />
        <br />
        <div ref={tc => (this.treeContainer = tc)}>
          <D3Tree
            data={root}
            translate={{ x: this.state.translateX, y: this.state.translateY }}
            orientation={'vertical'}
            allowForeignObjects
            nodeLabelComponent={{
              render: <TreeNode />,
              foreignObjectWrapper: {
                style: {
                  width: '150px',
                  x: -75,
                  y: -10
                }
              }
            }}
            nodeSvgShape={{ shape: 'none' }}
            separation={{ siblings: 1.4, nonSiblings: 1.5 }}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  searchTerm: state.filter.searchTerm
});

export default connect(mapStateToProps, {
  setSearchTerm,
  clearSearchTerm
})(TreeContainer);



// WEBPACK FOOTER //
// ./src/components/TreeContainer/TreeContainer.jsx